var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Content(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 4 C 12.972066 4 4 12.972074 4 24 C 4 35.027926 12.972066 44 24 44 C 35.027934 44 44 35.027926 44 24 C 44 12.972074 35.027934 4 24 4 z M 24 7 C 33.406615 7 41 14.593391 41 24 C 41 33.406609 33.406615 41 24 41 C 14.593385 41 7 33.406609 7 24 C 7 14.593391 14.593385 7 24 7 z M 18 16.5 A 2.5 2.5 0 0 0 18 21.5 A 2.5 2.5 0 0 0 18 16.5 z M 30 16.5 A 2.5 2.5 0 0 0 30 21.5 A 2.5 2.5 0 0 0 30 16.5 z M 15.773438 27.984375 A 1.50015 1.50015 0 0 0 14.582031 30.427734 C 16.77633 33.216322 20.192934 35 24 35 C 27.807066 35 31.22367 33.216322 33.417969 30.427734 A 1.50015 1.50015 0 1 0 31.060547 28.572266 C 29.414845 30.663678 26.872934 32 24 32 C 21.127066 32 18.585155 30.663678 16.939453 28.572266 A 1.50015 1.50015 0 0 0 15.773438 27.984375 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Content);
export default __webpack_public_path__ + "static/media/icons8-content.2a7a58275fbbf120554bc0196c9fd3e6.svg";
export { ForwardRef as ReactComponent };